import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import SelectSubject from "components/smea/Textfields/SelectSubject";
import SelectQuarter from "components/smea/Textfields/SelectQuarter";
import { number, object, string } from "yup";
import SelectComponent from "components/smea/Textfields/SelectComponents";
import useAxiosPrivate from "contexts/interceptors/axios";
import SchoolYearDatePicker from "components/smea/Textfields/SchoolYearDatePicker";
import SelectGradeLevel from "components/smea/Textfields/SelectGradeLevel";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "absolute",
  backgroundColor: "#e9e9e9",
  // background:
  //   "linear-gradient(40deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8))",
  //   border: "solid 2px #46e3be",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.3)",
  borderRadius: "10px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  p: 2,
  overflow: "auto",
  "@media (min-width: 10px)": {
    height: "90vh",
    width: "85vw",
  },

  "@media (min-width: 480px)": {
    height: "85vh",
    width: "80vw",
  },

  "@media (min-width: 640px)": {
    height: "75vh",
    width: "70vw",
  },

  "@media (min-width: 768px)": {
    height: "75vh",
    width: "70vw",
  },

  "@media (min-width: 1024px)": {
    height: "80vh",
    width: "70vw",
  },

  "@media (min-width: 1082px)": {
    height: "80vh",
    width: "65vw",
  },
};

export default function UpdateCompetencyModal({
  open,
  handleClose,
  data,
  updateTableFunction,
}) {
  const axiosPrivate = useAxiosPrivate();
  const [disabled, setDisabled] = useState(false);
  const [disableComponent, setDisableComponent] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const formik = useFormik({
    initialValues: {
      schoolYear: data?.schoolYear || "",
      competencyNo: data?.competencyNo || "",
      competencyDesc: data?.competencyDesc || "",
      subjectId: data?.subjectId || "",
      componentId: data?.componentId || "",
      gradeLevel: data?.gradeLevel || "",
      week: data?.week || "",
      quarter: data?.quarter || "",
    },

    validationSchema: object().shape({
      schoolYear: string().required("Required"),
      competencyNo: string().required("Required"),
      competencyDesc: string().required("Required"),
      subjectId: string().required("Required"),
      componentId: string(),
      gradeLevel: string().required("Required"),
      week: string().required("Required"),
      quarter: number().required("Required"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      setError("");

      if (!values.componentId) {
        // eslint-disable-next-line no-param-reassign
        values.componentId = null;
      }

      axiosPrivate
        .put(`/competency/updateCompetency/${data.id}`, values)
        .then(() => {
          alert("Competency Updated");
          updateTableFunction();
          handleClose();
        })
        .catch((err) => {
          setError(err?.response?.data?.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    if (data) {
      const initialValues = {
        schoolYear: data?.schoolYear || "",
        competencyNo: data?.competencyNo || "",
        competencyDesc: data?.competencyDesc || "",
        subjectId: data?.subjectId || "",
        componentId: data?.componentId || "",
        gradeLevel: data?.gradeLevel || "",
        week: data?.week || "",
        quarter: data?.quarter || "",
      };
      formik.setValues(initialValues);
    }
  }, [data]);

  useEffect(() => {
    if (formik.values) {
      let requiredFields;

      if (
        formik?.values?.subjectId === 6 ||
        formik?.values?.subjectId === 8 ||
        formik?.values?.subjectId === 9
      ) {
        requiredFields = formik.values;
      } else {
        const { componentId, ...otherValues } = formik.values;
        requiredFields = otherValues;
      }

      const areAllValuesFilled = Object.values(requiredFields).every(
        (value) => !!value
      );

      setDisabled(areAllValuesFilled);
    }
  }, [formik.values]);

  useEffect(() => {
    if (
      formik?.values?.subjectId === 6 ||
      formik?.values?.subjectId === 8 ||
      formik?.values?.subjectId === 9
    ) {
      setDisableComponent(false);
    } else {
      setDisableComponent(true);
    }
  }, [formik?.values]);

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
        // formik.resetForm();
        // setError("");
      }}
    >
      <Box
        variant="form"
        component="form"
        onSubmit={formik.handleSubmit}
        autoComplete="off"
        sx={style}
      >
        <Box
          sx={{
            position: "absolute",
            right: 20,
            cursor: "pointer",
            zIndex: 100,
          }}
        >
          <IconButton onClick={handleClose} sx={{ p: 0 }}>
            <CancelIcon />
          </IconButton>
        </Box>
        <Box>
          <Box
            sx={{
              backgroundColor: "#2e3887",
              borderRadius: "10px",
              width: "70%",
              p: 2,
              mb: 2,
            }}
          >
            <Typography
              sx={{ ml: 4, fontSize: 25, fontWeight: "bold", color: "#fff" }}
            >
              UPDATE COMPETENCY
            </Typography>
          </Box>
          {error}
          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 1)",
              boxShadow: "8px 8px 15px 3px rgba(0, 0, 0, 0.3)",
              borderRadius: "10px",
              p: 4,
              mx: 4,
            }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                xs={6}
                sx={{
                  zIndex: 1,
                  pr: 5,
                }}
              >
                <SchoolYearDatePicker
                  schoolYear={formik?.values?.schoolYear}
                  setSchoolYear={(sy) => formik.setFieldValue("schoolYear", sy)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="competencyNo"
                  label="Competency No"
                  size="small"
                  disabled={loading}
                  value={formik?.values?.competencyNo}
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBLur}
                  error={
                    formik?.touched?.competencyNo &&
                    Boolean(formik?.errors?.competencyNo)
                  }
                  helperText={
                    formik?.touched?.competencyNo &&
                    formik?.errors?.competencyNo
                  }
                  variant="outlined"
                  sx={{ pr: 5 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="competencyDesc"
                  label="Competency"
                  size="small"
                  disabled={loading}
                  value={formik?.values?.competencyDesc}
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBLur}
                  error={
                    formik?.touched?.competencyDesc &&
                    Boolean(formik?.errors?.competencyDesc)
                  }
                  helperText={
                    formik?.touched?.competencyDesc &&
                    formik?.errors?.competencyDesc
                  }
                  variant="outlined"
                  sx={{ pr: 5 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <SelectSubject
                  label={`Subject ${formik?.values?.subjectId ? "" : "*"}`}
                  // label="Subject"
                  name="subject"
                  // disabled={loading}
                  value={formik?.values?.subjectId}
                  onChange={(fieldName, selectedValue) => {
                    formik?.setFieldValue("subjectId", selectedValue);
                    formik?.setFieldValue("componentId", "");
                  }}
                  onBlur={formik?.handleBLur}
                  error={
                    formik?.touched?.subjectId &&
                    Boolean(formik?.errors?.subjectId)
                  }
                  helperText={
                    formik?.touched?.subjectId && formik?.errors?.subjectId
                  }
                  singleSelection
                  sx={{
                    width: "100%",
                    pr: 5,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black !important",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <SelectComponent
                  label={`Component ${formik?.values?.componentId ? "" : "*"}`}
                  // label="Subject"
                  name="componentId"
                  // disabled={loading}
                  value={formik?.values?.componentId}
                  onChange={(fieldName, selectedValue) => {
                    formik?.setFieldValue("componentId", selectedValue);
                  }}
                  subId={formik.values.subjectId}
                  onBlur={formik?.handleBLur}
                  disable={disableComponent}
                  error={
                    formik?.touched?.componentId &&
                    Boolean(formik?.errors?.componentId)
                  }
                  helperText={
                    formik?.touched?.componentId && formik?.errors?.componentId
                  }
                  sx={{
                    width: "100%",
                    pr: 5,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black !important",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <SelectGradeLevel
                  label={`Grade Level ${formik?.values?.gradeLevel ? "" : "*"}`}
                  name="gradeLevel"
                  value={formik?.values?.gradeLevel}
                  onChange={(fieldName, selectedValue) => {
                    formik?.setFieldValue("gradeLevel", selectedValue);
                  }}
                  sx={{
                    width: "100%",
                    pr: 5,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black !important",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label={`Week ${formik?.values?.week ? "" : "*"}`}
                  // label="Subject"
                  name="week"
                  // disabled={loading}
                  size="small"
                  value={formik?.values?.week}
                  onChange={formik.handleChange}
                  onBlur={formik?.handleBLur}
                  error={formik?.touched?.week && Boolean(formik?.errors?.week)}
                  helperText={formik?.touched?.week && formik?.errors?.week}
                  sx={{
                    width: "100%",
                    pr: 5,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black !important",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <SelectQuarter
                  label={`Quarter ${formik?.values?.quarter ? "" : "*"}`}
                  // label="Subject"
                  name="week"
                  // disabled={loading}
                  value={formik?.values?.quarter}
                  onChange={(fieldName, selectedValue) => {
                    formik?.setFieldValue("quarter", selectedValue);
                  }}
                  onBlur={formik?.handleBLur}
                  error={
                    formik?.touched?.quarter && Boolean(formik?.errors?.quarter)
                  }
                  helperText={
                    formik?.touched?.quarter && formik?.errors?.quarter
                  }
                  sx={{
                    width: "100%",
                    pr: 5,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black !important",
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            p: 2,
            zIndex: 10,
          }}
        >
          <Button
            disabled={!disabled}
            type="submit"
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: disabled ? "#2e3887" : "lightgray",
              color: "#fff",
              py: 1,
              width: "10vw",
              minWidth: "100px",
              "&:hover": {
                border: "solid 1px gray",
                backgroundColor: "lightgray",
                color: "#2b2b2b",
                fontWeight: "bold",
              },
            }}
          >
            <SaveIcon
              sx={{
                mr: 1,
              }}
            />
            Update
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
